import debounce from '../utils/debounce';
var Faq = /** @class */ (function () {
    function Faq(faq) {
        var _a;
        this.container = faq;
        this.question = faq.querySelector('[data-faq-question]');
        this.answerWrap = faq.querySelector('[data-faq-answer-wrap]');
        this.answer = faq.querySelector('[data-faq-answer]');
        this.scrollHeight = ((_a = this.answer) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
        this.init();
    }
    Faq.prototype.init = function () {
        var _this = this;
        var _a, _b;
        (_a = this.answerWrap) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
        (_b = this.question) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function (e) {
            e.preventDefault();
            _this.toggleAnswer();
        });
        window.addEventListener('resize', debounce(function () { return _this.updateScrollHeight(); }, 200));
    };
    Faq.prototype.updateScrollHeight = function () {
        if (!this.answerWrap || !this.answer)
            return;
        this.scrollHeight = this.answer.scrollHeight;
        if (!this.answerWrap.className.includes('hidden')) {
            this.answerWrap.setAttribute('style', "height: ".concat(this.scrollHeight, "px"));
        }
    };
    Faq.prototype.sendTrackingInfo = function () {
        var _a, _b, _c;
        if (!window.digitalData)
            return;
        var mainSection = (_a = this.container.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode;
        var sectionTitle = (_b = mainSection === null || mainSection === void 0 ? void 0 : mainSection.querySelector('.text-block__title')) === null || _b === void 0 ? void 0 : _b.innerText;
        var questionHeading = (_c = this.question) === null || _c === void 0 ? void 0 : _c.childNodes[1];
        var questionText = questionHeading === null || questionHeading === void 0 ? void 0 : questionHeading.innerText;
        var dataObj = {
            category: 'faq',
            action: sectionTitle,
            label: questionText,
        };
        window.digitalData.events = dataObj;
        try {
            window.Bootstrapper.ensEvent.trigger('faq-click');
        }
        catch (err) {
            //  Block of code to handle errors
            console.error("Couldn't reach Bootstrapper to trigger 'faq-click' with ".concat(JSON.stringify(dataObj)));
        }
    };
    Faq.prototype.toggleAnswer = function () {
        if (!this.answerWrap || !this.question)
            return;
        if (this.answerWrap.className.includes('hidden')) {
            this.question.classList.add('open');
            this.answerWrap.setAttribute('style', "height: ".concat(this.scrollHeight, "px"));
            this.answerWrap.classList.remove('hidden');
            this.sendTrackingInfo();
        }
        else {
            this.question.classList.remove('open');
            this.answerWrap.setAttribute('style', '');
            this.answerWrap.classList.add('hidden');
        }
    };
    return Faq;
}());
export default function createFaqs() {
    var faqs = Array.from(document.querySelectorAll('[data-faq-item]'));
    faqs.forEach(function (faq) { return new Faq(faq); });
}
